import { clientApi } from "@/utils/api";

import { TGetMeResDto } from "@/api/services/admin/auth/dtos/get-me.dto";
import { TLogoutResDto } from "@/api/services/admin/auth/dtos/logout.dto";
import { TRefreshTokenReqDto, TRefreshTokenResDto } from "@/api/services/admin/auth/dtos/refresh-token.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { TLoginResponse } from "@/features/auth/types/loginResponse";
import { TApiRes } from "@/types/api";
import { setToken } from "@/utils/token";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import Cookies from "js-cookie";

export const fetchMeApi = async (): Promise<TGetMeResDto> => {
  const { data } = await clientApi.get<TGetMeResDto>("/get-me");
  return data;
};

export const useMe = (options?: Omit<UseQueryOptions<TGetMeResDto>, "queryKey" | "queryFn">) => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER.FETCH_ME],
    queryFn: fetchMeApi,
    ...options,
  });
};

export const refreshTokenApi = async (): Promise<TRefreshTokenResDto> => {
  const accessToken = Cookies.get("admin-token");
  const refreshToken = Cookies.get("admin-refresh-token");
  if (!accessToken || !refreshToken) throw "Missing Token";
  const payload: TRefreshTokenReqDto = {
    accessToken,
    refreshToken,
  };
  const rs = await clientApi.post<TRefreshTokenResDto>("/refresh-token", payload);
  const { data } = rs.data;
  setToken(data.accessToken, data.refreshToken);
  return rs.data;
};

export const logoutApi = async (): Promise<TLogoutResDto> => {
  const refreshToken = Cookies.get("admin-refresh-token");
  const rs = await clientApi.post<TLogoutResDto>("/logout", { refreshToken });
  return rs?.data;
};

export const verifyOAuthTokenApi = async (token: string): Promise<TLoginResponse> => {
  const {
    data: { data },
  } = await clientApi.post<TApiRes<TLoginResponse>>("/oauth/verify-token", { token });
  return data;
};
